// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k6GU2BmFVQkHovm0sy7M{padding:6px 24px 20px}.Et_r6Qt5IsMLOioS8FhI{color:var(--content-primary-primary);margin-bottom:8px}.xpXiRli0lUymAmJQWuKO{flex-direction:column;gap:16px;padding-top:24px;display:flex}.VbhaoLluq00CK4Ugf52V{flex-direction:row;align-items:center;display:flex}.HZbDZdO3I3ofCkNuas8Z{width:110px;color:var(--content-primary-tertiary);flex-shrink:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `k6GU2BmFVQkHovm0sy7M`,
	"subsectionTitle": `Et_r6Qt5IsMLOioS8FhI`,
	"fields": `xpXiRli0lUymAmJQWuKO`,
	"field": `VbhaoLluq00CK4Ugf52V`,
	"label": `HZbDZdO3I3ofCkNuas8Z`
};
export default ___CSS_LOADER_EXPORT___;
